export default __webpack_public_path__ + "static/media/dropdown-down-arrow.c2d90aa5.svg";